/*
 * Fills Nosto placements (Nosto app "Nosto Placement" blocks, `.nosto_element`) that Nosto's own
 * page-load request left empty.
 *
 * The Nosto app embed tags every page with a currency variation (`.nosto_variation`, e.g. "NZD"),
 * sent as `current_variant_id`. This Nosto account has no price variations set up, so any request
 * carrying that field comes back with zero recommendations for every placement - confirmed by
 * replaying the page request with and without the field (28 Sep 2026). The same campaign requested
 * without the variation returns its products, so empty placements are re-requested that way and
 * rendered with Nosto's own template and injector.
 *
 * Remove this once the variation is configured in Nosto (or the app stops tagging it): placements
 * filled by Nosto itself are never touched here.
 */
(function () {
  if (!document.querySelector('.nosto_element')) return;

  window.nostojs =
    window.nostojs ||
    function (callback) {
      (window.nostojs.q = window.nostojs.q || []).push(callback);
    };

  function contextView(session, tagging) {
    var type = tagging && tagging.pageType;
    var productId = tagging && tagging.products && tagging.products[0] && tagging.products[0].product_id;
    var category = tagging && tagging.categories && tagging.categories[0];
    var searchTerm = tagging && tagging.searchTerms && tagging.searchTerms[0];

    if (type === 'front') return session.viewFrontPage();
    if (type === 'cart') return session.viewCart();
    if (type === 'notfound') return session.viewNotFound();
    if (type === 'product' && productId) return session.viewProduct(productId);
    if (type === 'category' && category) return session.viewCategory(category);
    if (type === 'search' && searchTerm) return session.viewSearch(searchTerm);
    return session.viewOther();
  }

  function emptyPlacements(ids) {
    return ids.filter(function (id) {
      var element = document.getElementById(id);
      return element && element.childElementCount === 0;
    });
  }

  function fillEmpty(api) {
    var ids = emptyPlacements(api.placements.getPlacements() || []);
    if (!ids.length) return;

    contextView(api.defaultSession().setResponseMode('HTML'), api.pageTagging())
      .setPlacements(ids)
      .load({ skipPageViews: true })
      .then(function (response) {
        var recommendations = (response && response.recommendations) || {};
        var stillEmpty = emptyPlacements(Object.keys(recommendations));
        if (!stillEmpty.length) return;

        var toInject = {};
        stillEmpty.forEach(function (id) {
          toInject[id] = recommendations[id];
        });
        return api.placements.injectCampaigns(toInject);
      })
      .catch(function (error) {
        console.error('Nosto placement fallback failed', error);
      });
  }

  window.nostojs(function (api) {
    var done = false;
    function runOnce() {
      if (done) return;
      done = true;
      fillEmpty(api);
    }
    // Wait for Nosto's own page-load render so a placement it fills is never re-rendered here.
    api.listen('postrender', runOnce);
    // Covers the case where that render already happened before this script ran.
    setTimeout(runOnce, 4000);
  });
})();
